class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content = this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

// class HeaderMenu extends DetailsDisclosure {
//   constructor() {
//     super();
//     this.header = document.querySelector('.header-wrapper');
//   }

//   onToggle() {
//     if (!this.header) return;
//     this.header.preventHide = this.mainDetailsToggle.open;

//     if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
//     document.documentElement.style.setProperty(
//       '--header-bottom-position-desktop',
//       `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
//     );
//   }
// }

// customElements.define('header-menu', HeaderMenu);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelectorAll("details");
    this.content = this.querySelector(".mega-menu__content");
    this.body = document.body;

    this.details.forEach((detail) => {
      detail.addEventListener("mouseenter", () => this.openMenu(detail));
      detail.addEventListener("mouseleave", () => this.closeMenu(detail));
    });
  }

  openMenu(detail) {
    detail.setAttribute("open", "");
    detail.classList.add("menu--open");
    this.body.classList.add("mega-menu--active", "has-dropdown-menu");
  }

  closeMenu(detail) {
    detail.removeAttribute("open");
    detail.classList.remove("menu--open");
    this.body.classList.remove("mega-menu--active", "has-dropdown-menu");
  }
}

customElements.define("header-menu", HeaderMenu);
